'use client';

import { createContextualCan } from '@casl/react';

import { AbilityContext } from '~/contexts/AbilityContext';
import type { AppAbility } from '~/shared/auth/permissions';

export const Can = createContextualCan<AppAbility>(AbilityContext.Consumer);
